import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-grafico-dona',
  templateUrl: './grafico-dona.component.html',
  styleUrls: ['./grafico-dona.component.css']
})
export class GraficoDonaComponent implements OnInit {


  ngOnInit(){}

  single:any = [
    {
      "name": "Germany",
      "value": 8940
    },
    {
      "name": "USA",
      "value": 5000
    },
    {
      "name": "France",
      "value": 7200
    },
    {
      "name": "India",
      "value": 7000
    }
  ];


  view: any[] = [1000, 400];

  // options
  showLegend: boolean = true;
  showLabels: boolean = true;

  colorScheme = {
    domain: ['#20018C', '#E44D25', '#07ABB3','#00AD59']
  };

  constructor() {
    //Object.assign(this, { this.single });
  }

  onSelect(event) {
    console.log(event);
  }

}
